var _circle, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperDnaInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.752,112.45A14.029,14.029,0,1,1,56.781,98.421,14.046,14.046,0,0,1,42.752,112.45Zm0-27A12.971,12.971,0,1,0,55.723,98.421,12.986,12.986,0,0,0,42.752,85.45Z",
    transform: "translate(-25.752 -81.421)",
    fill: "#635c7c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12.494 9.646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.541,93.47l4.358-.027a9.232,9.232,0,0,1-2.173,1.1,9.276,9.276,0,0,1-2.185-1.072m2.2,2.335a9.062,9.062,0,0,1,2.108,1.032l-4.21.026a9.172,9.172,0,0,1,2.1-1.057M39.527,98.05l6.446-.04a.88.88,0,0,1,.1.37v.045a.864.864,0,0,1-.1.371l-6.446.04a.859.859,0,0,1-.1-.37v-.045a.86.86,0,0,1,.1-.372m1.13,1.959,4.209-.026a9.138,9.138,0,0,1-2.1,1.057,9.18,9.18,0,0,1-2.114-1.031m2.122,2.293a9.368,9.368,0,0,1,2.067,1l-4.126.025a9.427,9.427,0,0,1,2.059-1.026m4.368-10.821A.6.6,0,0,0,46.4,91.1a.582.582,0,0,0-.379.732v0a.725.725,0,0,1-.061.425l-6.494.04a.722.722,0,0,1-.067-.421.59.59,0,0,0-1.129-.342c-.03.1-.3,2.1,2.924,3.649-2.426,1.2-2.968,2.627-2.947,3.267-.013.64.546,2.063,2.987,3.23a6.136,6.136,0,0,0-2.284,1.775.568.568,0,0,0-.227.344,2.374,2.374,0,0,0-.368,1.565.6.6,0,0,0,.571.412.624.624,0,0,0,.176-.029.583.583,0,0,0,.381-.73l0-.006a.75.75,0,0,1,.086-.5l6.443-.04a.766.766,0,0,1,.093.494.59.59,0,0,0,.389.727.61.61,0,0,0,.181.027.591.591,0,0,0,.559-.413,2.38,2.38,0,0,0-.387-1.561.575.575,0,0,0-.229-.34,6.117,6.117,0,0,0-2.305-1.748c2.424-1.2,2.966-2.626,2.945-3.266.013-.64-.547-2.063-2.988-3.23,3.2-1.593,2.911-3.591,2.88-3.685",
    transform: "translate(-38.247 -91.068)",
    fill: "#635c7c"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperDnaInactiveIcon);
export default __webpack_public_path__ + "static/media/swiper_dna_inactive_icon.b8af9a8e.svg";
export { ForwardRef as ReactComponent };